<template>
  <div class="actDetail">
    <div class="bg">
      <img :src="bgImgUrl" alt />
      <span
        class="absolute"
        v-if="actInfoData.stopFlag=='Y' && actInfoData.countNum!==actInfoData.serviceNum"
        @click.stop="signUp()"
      >正在报名</span>
      <span class="absolute" v-if="actInfoData.stopFlag=='N'">报名结束</span>
      <span
        class="absolute"
        v-if="actInfoData.countNum==actInfoData.serviceNum  && actInfoData.stopFlag=='Y'"
      >报名已满</span>
    </div>
    <div class="title">
      <h3>{{ actInfoData.serviceName }}</h3>
      <div>活动时间：{{ actInfoData.beginTimePj }}</div>
      <div>活动地点：{{ actInfoData.addr }}</div>
      <div>
        活动进度：{{
        (actInfoData.countNum || "") + "/" + (actInfoData.serviceNum || "")
        }}人已报名
      </div>
    </div>
    <div class="content">
      <div class="erTitle">
        01
        <span>活动介绍</span>
      </div>
      <div class="line">
        <div></div>
      </div>
      <div
        v-if="actInfoData.bizExtendContentVo"
        class="text"
        v-html="actInfoData.bizExtendContentVo.content"
      ></div>
    </div>

    <div class="bottom">
      <!-- <div class="fenx" @click="shareMenu">
        <img src="@/assets/images/Group40.png" alt />
        <span>分享活动</span>
      </div> -->
      <div
        class="apply"
        v-if="actInfoData.stopFlag=='Y' && actInfoData.countNum!==actInfoData.serviceNum"
        @click.stop="signUp()"
      >正在报名</div>
      <div
        class="apply"
        style="background: linear-gradient(180deg, #EAEAEA 0%, #D3D3D3 100%);color:#7A7A7A"
        v-if="actInfoData.stopFlag=='N'"
      >报名结束</div>
      <div
        class="apply"
        style="background: linear-gradient(180deg, #EAEAEA 0%, #D3D3D3 100%);color:#7A7A7A"
        v-if="actInfoData.countNum==actInfoData.serviceNum  && actInfoData.stopFlag=='Y'"
      >报名已满</div>
    </div>

    <div class="toast" v-if="isShow">
      请先完善个人信息
      <div class="switch" @click="perfectHandle('personInfo')">去完善</div>
    </div>
  </div>
</template>

<script>
import { Toast } from "vant";
import { getSignInfoDetail, applySignInfo } from "@/api/oldAgeActivity";
import { getIsComplateUserInfo } from "@/api/user.js";
import { mapState } from "vuex";
// import { areaCode } from "@/common/constants.js";
// import wx from "weixin-js-sdk";
// import { getDatas } from "@/api/user.js";
import { debounce } from "@/utils/index.js";

export default {
  name: "oldAgeActivityDetail",
  data() {
    return {
      actInfoData: {},
      bgImgUrl: "",
      hasUserInfo: "",
      isShow: false,
    };
  },
  computed: {
    ...mapState("user", ["openId"]),
  },
  methods: {
    // 获取详情数据
    getData() {
      getSignInfoDetail(this.$route.query).then((res) => {
        this.actInfoData = res;

        this.bgImgUrl = res.consultPictures
          ? `${process.env.VUE_APP_API_IMGURL}${res.consultPictures[0].imgUrl}`
          : "";
      });
    },
    // 报名按钮
    signUp() {
      debounce(this.signUpEd(), 1000);
    },
    // 报名
    async signUpEd() {
      // 1.判断是否登录
      if (!window.localStorage.getItem("openId")) {
        this.$router.push({
          name: "login",
        });
        return false;
      }
      // 调用是否完善个人信息接口
      await this.checkUserInfo();
      // 2.判断是否完善个人信息
      if (this.hasUserInfo != "0") {
        // 未完善个人信息
        // console.log(111)
        this.isShow = true;
      } else {
        applySignInfo({
          bizActivityRefId: this.$route.query.id,
          weixinId: this.$route.query.weixinId,
        })
          .then((res) => {
            if (res.code === 0) {
              // 报名成功
              Toast("活动报名成功");
              this.getData();
            } else {
              Toast(res.msg);
            }
          })
          .catch(() => {
            Toast("活动报名失败");
          });
      }
    },

    // 判断用户是否完善个人信息
    async checkUserInfo() {
      const { code } = await getIsComplateUserInfo({
        openId: this.openId,
      });
      this.hasUserInfo = code;
    },

    // 去完善个人信息页面
    perfectHandle(name) {
      this.$router.push(name);
    },

    // // 分享活动
    // shareMenu() {
    //   wx.ready(() => {
    //     // 调用微信的js-sdk方法，分享功能
    //     wx.updateAppMessageShareData({
    //       title: this.actInfoData.serviceName, // 分享标题
    //       desc: `确认分享${this.actInfoData.serviceName}活动吗？`, // 分享描述
    //       // link: "nandongmot.ucanyun.com/oldAgeActivityDetail", // 分享链接，该链接域名或路径必须与当前页面对应的公众号JS安全域名一致
    //       link: `${process.env.VUE_APP_API_ACT}/oldAgeActivityDetail?id=${this.$route.query.id}&weixinId=${this.$route.query.weixinId}`,
    //       imgUrl: require("@/assets/images/Group40.png"), // 分享图标
    //       success: function () {
    //         // 设置成功
    //         Toast("分享成功");
    //       },
    //     });
    //     wx.updateTimelineShareData({ 
    //       title: this.actInfoData.serviceName, // 分享标题
    //       desc: `确认分享${this.actInfoData.serviceName}活动吗？`, // 分享描述
    //       // link: "nandongmot.ucanyun.com/oldAgeActivityDetail", // 分享链接，该链接域名或路径必须与当前页面对应的公众号JS安全域名一致
    //       link: `${process.env.VUE_APP_API_ACT}/oldAgeActivityDetail?id=${this.$route.query.id}&weixinId=${this.$route.query.weixinId}`,
    //       imgUrl: require("@/assets/images/Group40.png"), // 分享图标
    //       success: function () {
    //         // 设置成功
    //         Toast("分享成功");
    //       },
    //     });
    //     wx.onMenuShareTimeline({
    //       title: this.actInfoData.serviceName, // 分享标题
    //       desc: `确认分享${this.actInfoData.serviceName}活动吗？`, // 分享描述
    //       link: `${process.env.VUE_APP_API_ACT}/oldAgeActivityDetail?id=${this.$route.query.id}&weixinId=${this.$route.query.weixinId}`, // 分享链接，该链接域名或路径必须与当前页面对应的公众号JS安全域名一致
    //       imgUrl: require("@/assets/images/Group40.png"), // 分享图标
    //       type: "", // 分享类型,music、video或link，不填默认为link
    //       dataUrl: "", // 如果type是music或video，则要提供数据链接，默认为空
    //       success: function () {
    //         // 用户点击了分享后执行的回调函数
    //         Toast("分享成功");
    //       },
    //       cancel: function () {
    //         // 用户取消分享后执行的回调函数
    //         Toast("分享取消");
    //       },
    //     });
    //     wx.onMenuShareAppMessage({
    //       title: this.actInfoData.serviceName, // 分享标题
    //       desc: `确认分享${this.actInfoData.serviceName}活动吗？`, // 分享描述
    //       link: `${process.env.VUE_APP_API_ACT}/oldAgeActivityDetail?id=${this.$route.query.id}&weixinId=${this.$route.query.weixinId}`, // 分享链接，该链接域名或路径必须与当前页面对应的公众号JS安全域名一致
    //       imgUrl: require("@/assets/images/Group40.png"), // 分享图标
    //       type: "", // 分享类型,music、video或link，不填默认为link
    //       dataUrl: "", // 如果type是music或video，则要提供数据链接，默认为空
    //       success: function () {
    //         // 用户点击了分享后执行的回调函数
    //         Toast("分享成功");
    //       },
    //       cancel: function () {
    //         // 用户取消分享后执行的回调函数
    //         Toast("分享取消");
    //       },
    //     });
    //   });
    // },
    // // 获取权限验证config需要的参数，
    // async config() {
    //   const thisPageUrl = location.href.split("#")[0];
    //   const json = {
    //     url: thisPageUrl,
    //   };
    //   const res = await getDatas({
    //     url: json.url,
    //     areaCode,
    //   });
    //   wx.config({
    //     debug: true, // 开启调试模式
    //     appId: res.appId, // 必填，公众号的唯一标识
    //     timestamp: res.timestamp, // 必填，生成签名的时间戳
    //     nonceStr: res.nonceStr, //生成签名的随机串
    //     signature: res.signature, //签名
    //     jsApiList: ["onMenuShareAppMessage","onMenuShareTimeline", "updateAppMessageShareData","updateTimelineShareData"], // 必填，需要使用的JS接口列表
    //   });
    // },
  },
  mounted() {
    // this.config();
    window.document.title = "活动详情";
    this.getData();
  },
};
</script>

<style lang="scss" scoped>
.toast {
  position: fixed;
  z-index: 999;
  top: 50%;
  left: 50%;
  // margin: 0 auto;
  transform: translate(-50%, -50%);
  width: 225px;
  height: 103px;
  opacity: 1;
  background: #626262;
  border-radius: 8px;
  opacity: 1;
  font-size: 16px;
  font-family: PingFang SC, PingFang SC-Bold;
  font-weight: 700;
  text-align: center;
  color: #ffffff;
  line-height: 50px;
  .switch {
    width: 77px;
    height: 24px;
    opacity: 1;
    background: #ffd63c;
    border-radius: 12px;
    opacity: 1;
    font-size: 16px;
    font-family: PingFang SC, PingFang SC-Bold;
    font-weight: 700;
    color: #543302;
    line-height: 24px;
    margin: 0 auto;
    text-align: center;
  }
}
.actDetail {
  width: 100vw;
  // height: 100vh;
  padding-bottom: 49px;
  .bg {
    width: 100%;
    height: 180px;
    position: relative;
    img {
      width: 100%;
      height: 100%;
    }
    .absolute {
      position: absolute;
      width: 64px;
      height: 32px;
      font-style: normal;
      font-weight: 500;
      font-size: 12px;
      text-align: center;
      line-height: 32px;
      right: 16px;
      bottom: -16px;
      color: #000000;
      background: linear-gradient(180deg, #ffd63c 0%, #f5c100 100%);
      border-radius: 4px;
    }
  }
  .title {
    margin-top: 25px;
    padding: 0 20px;
    h3 {
      font-style: normal;
      font-weight: 500;
      font-size: 20px;
      line-height: 24px;
      text-align: center;

      color: #000000;
      margin-bottom: 15px;
    }
    div {
      font-style: normal;
      font-weight: 400;
      font-size: 14px;
      line-height: 24px;

      color: #333333;
    }
  }
  .content {
    overflow: hidden;

    margin-top: 37px;
    padding: 0 20px;
    background: url("../../assets/images/Ellipse7.png") no-repeat 108px 0;
    .erTitle {
      margin-top: 20px;
      font-weight: 400;
      font-size: 38px;
      color: #333333;
      text-align: center;
      font-style: normal;

      span {
        font-weight: 500;
        font-size: 18px;
        line-height: 21px;
      }
    }
    .line {
      width: 146px;
      height: 0px;
      margin: 20px auto 0;
      border: 1px solid #ecba00;
      div {
        width: 40px;
        height: 0px;
        border: 3px solid #ffd63c;
        margin: -3px 75px;
      }
    }
    .text {
      width: 100%;
      overflow: hidden;
      margin-top: 38px;
      font-style: normal;
      font-weight: 400;
      font-size: 14px;
      line-height: 21px;
      color: #555555;
      text-indent: 2em;

      p {
        width: 100%;
        img {
          width: 100% !important;
          height: auto;
        }
      }
    }
  }
  .bottom {
    position: fixed;
    display: flex;
    left: 0;
    bottom: 0;
    width: 100%;
    height: 49px;
    display: flex;
    box-shadow: 0px -1px 1px rgba(0, 0, 0, 0.16);

    .apply {
      flex-grow: 1;
      text-align: center;
      line-height: 49px;
      background: #ffd63c;
      font-style: normal;
      font-weight: 500;
      font-size: 16px;

      color: #000000;
    }
  }
}
</style>
